module.exports = __webpack_public_path__ + "img/design1.711c528f.png";